import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {Paragraph} from 'src/designSystem2021Components/text-v2';

import ReferWithdrawSuccess from 'src/images/refer-withdraw.svg';
import css from 'src/components/referral-external/refer-success.css';


export const WithDrawSuccess = (params: {referralLinkId: string}) => {
  const {t} = useLabelTranslation();

  return (
    <div className={css.container}>
      <ReferWithdrawSuccess />
      <Paragraph>{`${t(
        'Your_candidature_has_been_withdrawn_This_referral_submission_will_not_be_processed_further_and_the_referrer_shall_be_notified_accordingly',
        'Your candidature has been withdrawn. This referral submission will not be processed further and the referrer shall be notified accordingly',
      )}.`}</Paragraph>
    </div>
  );
};

export const TokenInvalid = (params: {referralLinkId: string}) => {
  const {t} = useLabelTranslation();

  return (
    <div className={css.container}>
      <Paragraph>{`${t(
        'You_have_already_been_considered_for_the_referral_so_this_step_is_no_longer_required',
        'You have already been considered for the referral, so this step is no longer required',
      )}.`}</Paragraph>
    </div>
  );
};
